import { Button } from '@/components/ui/button'
import { Filter } from 'lucide-react'

export const FakeFiller = ({ onClick, isHidden = false }: { onClick: () => void; isHidden?: boolean }) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'DEVELOPMENT') return null
  if (isHidden) return null

  return (
    <div className='flex items-center justify-end pb-2'>
      <Button onClick={onClick} variant='outline' type='button'>
        <Filter /> Fake Filler
      </Button>
    </div>
  )
}
